import * as React from 'react';
import BackButton from '../navigation/BackButton';
import { CommonOperations, contains } from '../../store/permissions';
import { Redirect } from "react-router-dom";
import { ApplicationState } from '../../store';
import { connect } from 'react-redux';
import { UserState } from '../../store/User';
import { css, Overlay } from 'office-ui-fabric-react';
import Spinner from "../common/Spinner";

export type OwnProps = {
    title: string;
    className?: string;
    requiredPermission?: CommonOperations;
    isLoading?: boolean;
}

type StateProps = { 
    user: UserState;
}

type Props = OwnProps & StateProps;

const SettingsPage = (props: React.PropsWithChildren<Props>) => {
    const { user, requiredPermission, title, className, isLoading, children } = props;

    if (requiredPermission !== undefined && !contains(user.permissions.common, requiredPermission)) {
        return <Redirect to="/" />;
    }

    return <div className="page-settings">
        <div className="page-settings-header">
            <div className="page-navigation">
                <BackButton />
            </div>
            <h2>{title}</h2>
        </div>
        <div className={css('scrollable', className)}>
            {children}
            {isLoading && <Overlay><Spinner /></Overlay>}
        </div>
    </div>
}


function mapStateToProps(state: ApplicationState, ownProp: OwnProps) {
    return {
        user: state.user
    };
}

export default connect(mapStateToProps)(SettingsPage);